export const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  welcomeBonus: 'Бүртгэлийн урамшуулал',
  purchaseReward: 'Худалдан авалтын оноо',
  reviewReward: 'Сэтгэгдлийн урамшуулал',
  manualAdjustment: 'Тохируулга',
  voucherConversion: 'Ваучер болгосон',
  pointsReversed: 'Оноо буцаасан',
  refundReversal: 'Буцаалтын хасалт',
  expiredPoints: 'Хугацаа дууссан',
  other: 'Бусад',
}

export const VOUCHER_STATUS_LABELS: Record<string, string> = {
  active: 'Идэвхтэй',
  used: 'Ашигласан',
  expired: 'Хугацаа дууссан',
  canceled: 'Цуцлагдсан',
}
